import React, { useState } from "react";
import withIntl from "../../utils/withIntl";
import { Grid, IconButton, TextField, Typography } from "@material-ui/core";
import { Delete } from "@material-ui/icons";

function RepeatSetting(props) {
  const [repeatedPattern, setRepeatedPattern] = useState(props.repeatedPattern);

  return (
    <Grid container spacing={1}>
      <Grid item xs={6}>
        <Typography>{props.intl.formatMessage({ id: "minutes" })}</Typography>
      </Grid>
      <Grid item xs={3}>
        <TextField
          value={repeatedPattern.repeat.minutes}
          onChange={(e) => {
            let newR = { ...repeatedPattern };
            newR.repeat.minutes = e.target.value;
            setRepeatedPattern(newR);
            props.onChange(newR);
          }}
        />
      </Grid>
      <Grid item xs={3}>
        <IconButton onClick={() => props.onRemove()}>
          <Delete />
        </IconButton>
      </Grid>
      <Grid item xs={6}>
        <Typography>{props.intl.formatMessage({ id: "ta_merchant.order_max_number_of_days_ahead_2" })}</Typography>
      </Grid>
      <Grid item xs={6}>
        <TextField
          value={repeatedPattern.numberOfDaysAhead}
          onChange={(e) => {
            let newR = { ...repeatedPattern };
            newR.numberOfDaysAhead = e.target.value;
            setRepeatedPattern(newR);
            props.onChange(newR);
          }}
        />
      </Grid>
    </Grid>
  );
}

export default withIntl(RepeatSetting);
